import { render } from "./NeuroSurgery.vue?vue&type=template&id=9becc0ea&scoped=true"
import script from "./NeuroSurgery.vue?vue&type=script&lang=ts"
export * from "./NeuroSurgery.vue?vue&type=script&lang=ts"

import "./NeuroSurgery.vue?vue&type=style&index=0&id=9becc0ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9becc0ea"

export default script